/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Turkish (Turkey)
export default {
  'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Seçimi temizle',
  'paginated-picker.async-select.menu-list.error-message.error-message': 'Veriler alınamadı',
  'paginated-picker.async-select.menu-list.error-message.retry-message': 'Yeniden denemek için tıklayın',
  'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Yükleniyor...',
  'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Daha fazla göster',
  'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
  'paginated-picker.async-select.select.no-options-message.no-options-message': 'Eşleşme bulunamadı',
  'paginated-picker.async-select.select.option.error-message': 'Veriler alınamadı',
  'paginated-picker.async-select.select.option.retry-message': 'Yeniden denemek için tıklayın',
  'paginated-picker.async-select.select.search-placeholder': 'Ara',
  'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Tam listeyi göster'
};